<template>
    <!--计划详情-->
    <div class="check-receipt-detail">
        <Row type="flex" justify="space-between" align="middle">
            <div class="title-l">
                <router-link to="/index/plan" class="span-box">
                    <Icon type="ios-arrow-back" />
                    <span>计划详情</span>
                </router-link>
            </div>
            <!-- <div>
                <Button type="primary" size="large" @click="quoteOrder">引用</Button>
                <span></span>
                <Button type="primary" size="large" :loading="loadingPrint" @click="printReceipt">打印</Button>
            </div> -->
        </Row>
        <div id="Print-s">
            <div class="receipt-head-box">
                <div class="company-signature print-show">
                    <span>售卖单位（签章）：</span>
                    <span>采购单位（签章）：</span>
                    <span class="last-span">
                        年&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        月&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        日&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                </div>
                <div class="receipt-label">
                    单据信息
                </div>
                <div class="receipt-info">
                    <Row>
                        <Col :span="8">
                            <span>计划单号：{{ receiptInfo.projectId }}</span>
                        </Col>
                        <Col :span="8">
                            <span>计划状态：{{ receiptInfo.projectStatus }}</span>
                        </Col>
                        <Col :span="8">
                            <span>计划版本：{{ receiptInfo.versionId }}</span>
                        </Col>
                        <Col :span="8">
                            <span>计划类型：{{ receiptInfo.projectType }}</span>
                        </Col>
                        <Col :span="8">
                            <span>计划期：{{ receiptInfo.period }}</span>
                        </Col>
                        <Col :span="8">
                            <span>采购单位编码：{{ receiptInfo.organNo }}</span>
                        </Col>
                        <Col :span="24">
                            <span>采购单位：{{ receiptInfo.path }}</span>
                        </Col>
                    </Row>
                    <Divider />
                </div>
            </div>
            <Table :columns="columns" :data="receiptData" :loading="loading">
                <template slot-scope="{ row }" slot="productCount">
                    <Input
                        v-if="$route.query.status === '待填报'"
                        v-model="row.productCount"
                        type="number"
                        @on-change="productCountChange(row)"
                        @on-blur="setTotalValue(row)"
                        class="input-number"/>
                    <span v-else>{{row.productCount}}</span>
                </template>
                <template slot-scope="{ row }" slot="unitPrice">
                    <Input
                        v-if="$route.query.status === '待填报'"
                        v-model="row.unitPrice"
                        type="number"
                        @on-change="unitPriceChange(row)"
                        @on-blur="setTotalValue(row)"
                        class="input-number"/>
                    <span v-else>{{row.unitPrice}}</span>
                </template>
            </Table>
            <Row class="table-footer-box" type="flex" justify="end">
                <div class="monry-detail-info">
                    <span>
                        共： <b class="weight"> {{ receiptInfo.totalItem || 0 }} </b>项
                    </span>
                    <span>
                        数量合计： <b class="weight"> {{ receiptInfo.totalNumber || 0 }} </b>
                    </span>
                    <!-- <span>
                        可供应数量合计： <b class="weight"> {{ receiptInfo.supplyCount || 0 }} </b>
                    </span> -->
                    <span>
                        金额合计： <b class="weight"> ￥{{ receiptInfo.totalValue || 0 }}元 </b>
                    </span>
                </div>
            </Row>
            <div class="model-submit-btn" v-if="$route.query.status === '待填报'">
                <Button type="primary" :loading="loadingSubmit" :disabled="isDisable">
                    <span v-if="!loading" @click="submitModel">报价</span>
                    <span v-else>正在提交</span>
                </Button>
            </div>
            <div class="company-signature-footer print-show">
                <p>
                    售卖人：<span></span>
                </p>
                 <p>
                    采购人：<span></span><span></span>
                </p>
                 <p>
                    验收人：
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import printJS from 'print-js';
import { getOneProject, quoTePrice } from '@/graphql/graphql.js';
import Cookies from 'js-cookie';
import NP from 'number-precision';
import { clone } from '@/assets/js/clone.js';
export default {
    data() {
        return {
            // table 头部定义
            // serialNum 行号
            loading: false,
            loadingPrint: false,
            modalPrint: false,
            columns: [
                {
                    title: '行项目',
                    key: 'serialNum',
                    minWidth: 80,
                    className: 'serialNum'
                },
                {
                    title: '物资名称',
                    key: 'productName',
                    minWidth: 100,
                    className: 'productName'
                },
                {
                    title: '物资编码',
                    key: 'productNo',
                    minWidth: 100,
                    className: 'productNo'
                },
                {
                    title: '类别名称',
                    key: 'classifyName',
                    minWidth: 100,
                    className: 'classifyName'
                },
                {
                    title: '物资规格',
                    key: 'productSpectype',
                    minWidth: 100,
                    className: 'productSpectype'
                },
                // {
                //     title: '可供应数量',
                //     key: 'supplyCount',
                //     minWidth: 100,
                //     className: 'supplyCount'
                // },
                {
                    title: '数量',
                    key: 'productCount',
                    minWidth: 100,
                    className: 'productCount',
                    slot: 'productCount'
                },
                {
                    title: '单价（元）',
                    key: 'unitPrice',
                    minWidth: 100,
                    className: 'unitPrice',
                    slot: 'unitPrice'
                },
                {
                    title: '金额（元）',
                    key: 'totalPrice',
                    minWidth: 100,
                    className: 'totalPrice'
                }
            ],
            isDisable: false,
            loadingSubmit: false,
            // table 数据部分
            receiptData: [],

            // 单据信息
            receiptInfo: {},

            printJsOption: {
                printable: 'Print-s',
                type: 'html',
                header: '食材销售(入库)清单',
                maxWidth: 1060,
                headerStyle: 'font-size: 30px;color: #000;text-align: center;width: 100%; background: #fff;',
                css: 'static/css/print.css',
                font_size: '18pt',
                targetStyles: ['*']
            }
        };
    },

    mounted() {
        if (this.$route.query.projectId) {
            this.getOriginReceiptDetail();
        } else {
            this.$setNotice('请选择详情');
            this.$router.push('/index/plan_price');
        }
    },

    methods: {
        // 打印按钮
        printReceipt() {
            this.loadingPrint = true;
            setTimeout(() => {
                printJS(this.printJsOption);
                this.loadingPrint = false;
            }, 2000);
        },
        // 查看单据详情
        getOriginReceiptDetail() {
            this.loading = true;
            this.$apollo.query({
                query: getOneProject,
                context: { useApi1: false },
                variables: {
                    projectId: this.$route.query.projectId
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                this.loading = false;
                const data = res.data.getOneProject;
                if (data && data.code === 200) {
                    this.receiptInfo = data.data;
                    this.receiptData = data.data.items;
                } else {
                    this.$setNotice('详情获取失败,请重新选择');
                }
            });
        },
        submitModel() {
            this.isDisable = true;
            this.loadingSubmit = true;
            let newArr = [];
            const list = clone(this.receiptData);
            let st = true;
            list.forEach((ele, key) => {
                if (!ele.unitPrice || Number(ele.unitPrice) <= 0) {
                    st = false;
                }
            });
            if (st) {
                list.forEach((ele, key) => {
                    newArr.push({
                        serialNum: key + 1,
                        productCount: ele.productCount.toString(),
                        productNo: ele.productNo,
                        unitPrice: ele.unitPrice.toString(),
                        totalPrice: ele.totalPrice.toString()
                    });
                });
                const params = {
                    projectId: this.$route.query.projectId.toString(),
                    totalValue: this.receiptInfo.totalValue,
                    totalNumber: this.receiptInfo.totalNumber,
                    totalItem: this.receiptInfo.totalItem,
                    items: newArr
                };
                this.$apollo.mutate({
                    mutation: quoTePrice,
                    context: { useApi1: false },
                    variables: {
                        supplierNo: Cookies.getJSON('USER-INFO').supplierNo,
                        project: params
                    }
                }).then(res => {
                    this.loadingSubmit = false;
                    const data = res.data.quoTePrice;
                    if (data && data.code === 200) {
                        setTimeout(() => {
                            this.isDisable = false;
                        }, 1000);
                        this.isDisable = true;
                        this.$setNotice('提交成功');
                        this.$router.push('/index/plan_price');
                    } else {
                        setTimeout(() => {
                            this.isDisable = false;
                        }, 1000);
                        this.$Notice.open({
                            title: '提交失败',
                            desc: data.message
                        });
                    }
                });
            } else {
                this.$setNotice('请填写单价');
                setTimeout(() => {
                    this.isDisable = false;
                }, 1000);
                this.loadingSubmit = false;
            }
        },
        productCountChange(val) {
            if (Number(val.productCount) > 0) {
                val.totalPrice = NP.round(NP.times(+val.unitPrice, +val.productCount), 2);
                this.receiptData[val._index] = val;
            } else {
                val.productCount = 0;
                val.totalPrice = 0;
            }
        },
        unitPriceChange(val) {
            if (Number(val.unitPrice) > 0) {
                val.totalPrice = (Number(val.unitPrice) * Number(val.productCount)).toFixed(2);
                this.receiptData[val._index] = val;
            } else {
                val.unitPrice = 0;
                val.totalPrice = 0;
            }
        },
        setTotalValue(val) {
            val.productCount = Number(val.productCount).toFixed(3);
            val.unitPrice = Number(val.unitPrice).toFixed(2);
            val.totalPrice = Number(val.totalPrice).toFixed(2);
            let count = 0;
            let priceSum = 0;
            this.receiptData.forEach(ele => {
                count += Number(ele.productCount);
                priceSum += Number(ele.totalPrice);
            });
            this.receiptInfo.totalNumber = count.toFixed(3);
            this.receiptInfo.totalValue = priceSum.toFixed(2);
        }
    }
};
</script>

<style lang="stylus">

@import '../../assets/stylus/views/receipt-detail.styl'

</style>



// WEBPACK FOOTER //
// src/views/plan/detail.vue